import { PageToolbar } from '@app/components/page-toolbar/PageToolbar';
import { Box } from '@mui/material';
import { LiveTopicsCategoryFilter } from './LiveTopicsCategoryFilter';
import { LiveTopicsTextFilter } from './LiveTopicsTextFilter';

export interface LiveTopicsPanelCategoryToolbarProps {
  filters: {
    categoryOptions: string[];
    selectedCategories: string[];
    onSelectedCategoriesChange: (value: string[]) => void;
    textFilter: string;
    onTextFilterChange: (value: string) => void;
  };
}

/**
 * Toolbar strip for the Live Topics panel list view: category multi-select and fuzzy text filter.
 */
export function LiveTopicsPanelCategoryToolbar({ filters }: LiveTopicsPanelCategoryToolbarProps) {
  const {
    categoryOptions,
    selectedCategories,
    onSelectedCategoriesChange,
    textFilter,
    onTextFilterChange,
  } = filters;

  return (
    <PageToolbar
      sx={{
        px: 1.5,
        pt: 2,
      }}
    >
      <Box sx={{ display: 'flex', flexWrap: 'wrap', width: '100%', gap: 1 }}>
        <Box sx={{ flex: '1 1 280px' }}>
          <LiveTopicsCategoryFilter
            options={categoryOptions}
            value={selectedCategories}
            onChange={onSelectedCategoriesChange}
          />
        </Box>
        <Box sx={{ flex: '1 1 220px' }}>
          <LiveTopicsTextFilter value={textFilter} onChange={onTextFilterChange} />
        </Box>
      </Box>
    </PageToolbar>
  );
}
